import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'underscoreRemovePipe',
  standalone: true
})
export class underscoreRemovePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return value;
    }
    // Remove underscores and apply titlecase
    return value.replace(/_/g, ' ').replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
